function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("title", null, "ico_combine");

var _ref2 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "ico_combine",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "M16.5684431,21.9991582 C16.5458267,22.000687 16.5230041,22.0014637 16.5,22.0014637 C16.2152766,22.0014637 15.9583456,21.8824705 15.7762243,21.6915016 L9.39486047,18.5327265 L3.49238499,21.8718412 C2.82575669,22.2489624 2,21.7673708 2,21.0014637 L2,6.60146371 C2,6.24106271 2.19393008,5.90854224 2.50761501,5.7310862 L8.87125137,2.1310862 C9.04402232,2.0333472 9.23907486,1.99067955 9.43155687,2.00376918 C9.45417329,2.00224047 9.47699594,2.00146371 9.5,2.00146371 C9.78472337,2.00146371 10.0416544,2.12045687 10.2237757,2.31142577 L16.6051395,5.47020089 L22.507615,2.1310862 C23.1742433,1.75396504 24,2.23555663 24,3.00146371 L24,17.4014637 C24,17.7618647 23.8060699,18.0943852 23.492385,18.2718412 L17.1287486,21.8718412 C16.9559777,21.9695802 16.7609251,22.0122479 16.5684431,21.9991582 Z M15.5,7.15477059 L10.5,4.67977059 L10.5,16.8481568 L15.5,19.3231568 L15.5,7.15477059 Z M17.5,7.26181902 L17.5,19.3639655 L22,16.8182513 L22,4.71610474 L17.5,7.26181902 Z M8.5,4.63896188 L4,7.18467616 L4,19.2868227 L8.5,16.7411084 L8.5,4.63896188 Z",
  fillOpacity: 0.2,
  fill: "#142428",
  fillRule: "nonzero"
}), React.createElement("rect", {
  id: "Rectangle",
  stroke: "#979797",
  fill: "#D8D8D8",
  opacity: 0,
  x: 0.5,
  y: 0.5,
  width: 24,
  height: 24
}));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 25 25",
    version: 1.1,
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _ref, _ref2, _ref3);
};

export default __webpack_public_path__ + "static/media/ico_map.2a45344e.svg";
export { SvgComponent as ReactComponent };